/* Anaris 2026-11 "Biblioteket": rörelse och sigillet på startsidan.
   Inget här påverkar ordern. Allt rörligt stängs av vid minskad rörelse. */
(function () {
  'use strict';
  var RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var doc = document.documentElement;

  /* ---------- 1. Mjukt upp och in vid scroll ---------- */
  function reveal() {
    if (RM || !('IntersectionObserver' in window)) return;
    doc.classList.add('ax-js');
    var sel = [
      '.anaris-lp h2', '.anaris-lp .bpb-head>p', '.anaris-lp .bpb-item', '.anaris-lp .usp>div',
      '.anaris-lp .bpm figure', '.anaris-lp .acc details', '.anaris-lp .mtile', '.anaris-lp .split>*',
      '.anaris-lp .bpb-split>*', '.anaris-lp .darkc>p', '.anaris-lp .bpb-foot', '.anaris-cart-trust .act-item'
    ].join(',');
    var vh = window.innerHeight;
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('ax-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    var count = new Map();
    Array.prototype.forEach.call(document.querySelectorAll(sel), function (el) {
      if (el.closest('.axh')) return;
      var r = el.getBoundingClientRect();
      if (r.top < vh * 0.92) return; /* redan synlig: rör inte, ingen blinkning */
      var p = el.parentElement, i = count.get(p) || 0; count.set(p, i + 1);
      el.style.setProperty('--ax-d', Math.min(i * 70, 420) + 'ms');
      el.classList.add(el.tagName === 'H2' ? 'ax-press' : 'ax-r');
      io.observe(el);
    });
  }

  /* ---------- 2. Motiven lutar efter muspekaren ---------- */
  function tilt() {
    if (RM || !window.matchMedia('(pointer:fine)').matches) return;
    Array.prototype.forEach.call(document.querySelectorAll('.anaris-lp .bpm figure'), function (f) {
      f.addEventListener('pointermove', function (e) {
        var r = f.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        f.style.setProperty('--ry', (x * 14).toFixed(2) + 'deg'); f.style.setProperty('--rx', (-y * 14).toFixed(2) + 'deg');
      });
      f.addEventListener('pointerleave', function () { f.style.setProperty('--ry', '0deg'); f.style.setProperty('--rx', '0deg'); });
    });
  }

  /* ---------- 3. Nedräkning till sista beställningsdag ---------- */
  function deadlines() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ax-deadline]'), function (el) {
      var d = el.getAttribute('data-ax-deadline') || '', m = d.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (!m) return;
      /* Slutet av dagen i Sverige (vintertid, UTC+1) */
      var end = Date.UTC(+m[1], +m[2] - 1, +m[3], 22, 59, 59);
      var now = Date.now();
      if (now > end) return;
      var days = Math.ceil((end - now) / 864e5) - 1;
      var tpl = days <= 0 ? (el.getAttribute('data-ax-one') || '') : (el.getAttribute('data-ax-tpl') || '');
      if (!tpl) return;
      var t = el.querySelector('span') || el;
      t.textContent = tpl.replace('{d}', String(days)).replace(/^1 dagar\b/, '1 dag');
      el.hidden = false;
    });
  }

  /* ---------- 4. Sigillet som präglas ---------- */
  function seal(root) {
    if (root.__axs) return; root.__axs = true;
    var tp = root.querySelector('[data-axs-text]'); if (!tp) return;
    var text = tp.parentNode, base = parseFloat(text.getAttribute('font-size')) || 4.3, maxw = parseFloat(text.getAttribute('data-maxw')) || 31;
    var input = root.querySelector('input'), form = root.querySelector('form');
    var upper = root.getAttribute('data-upper') === '1';
    var demo = (root.getAttribute('data-demo') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var di = 0, timer = null, typing = null, busy = false, pending = null;
    function fit(n) {
      tp.textContent = n || ' ';
      text.setAttribute('font-size', base);
      try { var w = text.getComputedTextLength(); if (w > maxw) text.setAttribute('font-size', (base * maxw / w).toFixed(3)); } catch (e) {}
    }
    function clean(n) { n = (n || '').replace(/\s+/g, ' ').trim().slice(0, 28); return upper ? n.toUpperCase() : n; }
    function press(n) {
      n = clean(n);
      if (RM) { fit(n); return; }
      if (busy) { pending = n; return; }
      busy = true; root.classList.remove('is-pressing'); void root.offsetWidth; root.classList.add('is-pressing');
      setTimeout(function () { fit(n); }, 520);
      setTimeout(function () { root.classList.remove('is-pressing'); busy = false; if (pending !== null) { var p = pending; pending = null; press(p); } }, 1180);
    }
    function nextDemo() { if (!demo.length) return; press(demo[di % demo.length]); di++; }
    function startDemo() { stopDemo(); timer = setInterval(nextDemo, RM ? 4200 : 3600); }
    function stopDemo() { if (timer) { clearInterval(timer); timer = null; } }
    fit(clean(demo[0] || ''));
    di = 1;
    var started = false;
    function kick() { if (started) return; started = true; setTimeout(function () { press(demo[0] || ''); startDemo(); }, 700); }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { kick(); } else if (started && !input.value) { stopDemo(); started = false; } }); }, { threshold: 0.35 });
      io.observe(root);
    } else kick();
    if (input) {
      input.addEventListener('focus', stopDemo);
      input.addEventListener('input', function () {
        stopDemo(); clearTimeout(typing);
        typing = setTimeout(function () { press(input.value || demo[0] || ''); }, 420);
      });
    }
    /* Namnet skickas i adressens #-del, som aldrig når servern eller annonsmätningen. */
    if (form) form.addEventListener('submit', function (e) {
      var v = input ? input.value.replace(/\s+/g, ' ').trim() : '';
      e.preventDefault();
      window.location.href = (form.getAttribute('action') || '/products/bokpraglaren') + (v ? '#namn=' + encodeURIComponent(v) : '');
    });
  }

  function init() {
    reveal(); tilt(); deadlines();
    Array.prototype.forEach.call(document.querySelectorAll('[data-axs]'), seal);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { deadlines(); Array.prototype.forEach.call(document.querySelectorAll('[data-axs]'), seal); tilt(); });
})();
